import axios from 'axios';

const axiosInstance = axios.create({
//   baseURL: 'https://volto.technogenesis.in/volto-php', 
  baseURL: `${window.location.origin}/volto-php`,
   
  headers: {
    'Content-Type': 'application/json', 
   
  },
});

export default axiosInstance;